const ERROR_RESPONSE = {
    status: 'error'
};
const TIMEOUT_MS = 10000;

/**
 * 認証リクエストを送信し、レスポンスを返す。
 * @returns {Promise<Object>} - サーバーからのレスポンスオブジェクト（もしくはエラーコード）
 */
const sendAuthRequest = async () => {
    const endpoint = '/auth/';
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);


    const init = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        signal: controller.signal
    };



    try {
        const response = await fetch(endpoint, init);

        clearTimeout(timeoutId);

        if (!response.ok) {
            throw new Error(` ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        if (error.name === 'AbortError') {
            // eslint-disable-next-line no-console
            console.error('Request timed out');
        } else {
            // eslint-disable-next-line no-console
            console.error(error);
        }

        return ERROR_RESPONSE;
    }
};


/**
 * ログイン状態に応じて表示状態を切替。
 *
 * @param {Object} response - サーバーからのレスポンスオブジェクト
 */
const handleLoginStatus = (response) => {
    const bodyElement = document.body;

    // 既存のログイン状態クラスを削除
    bodyElement.classList.remove('is-login-prime', 'is-login');

    if (response.status !== 'OK' || Object.keys(response.data).length === 0) {
        return;
    }

    const {bucketList} = response.data;
    const hasCanimePrime = bucketList.some((bucket) => bucket.bucketKey === 'canime-prime');

    if (hasCanimePrime) {
        bodyElement.classList.add('is-login-prime'); // プライム会員
    } else {
        bodyElement.classList.add('is-login'); // ログインユーザー
    }
};

/**
 * 認証チェックとログイン状態の反映を実行
 */
export default async () => {
    const response = await sendAuthRequest();

    handleLoginStatus(response);
};
